import { Component, OnInit, Input, ViewChild, TemplateRef, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { UntypedFormBuilder} from '@angular/forms';
import { TypesService } from '../../../services/types.service';
import { Type } from '../../../db/type';
import { Contact } from '../../../db/contact';


import { ActivitiesService } from '../../../services/activities.service';
import { Activities } from '../../../db/activities';
import {DeadlinerulesService} from '../../../services/deadlinerules.service'
import {NotificationService} from '../../../../../../core/src/lib/notification.service';
import { ModelList } from 'projects/core/src/include/modellist';
import { Filter, FilterMode, Ordering, OrderingMode, ToastMode, User } from 'projects/core/src/include/structures';
import { UserService } from 'projects/core/src/lib/user.service';
import { Helper } from 'projects/core/src/helper';
import { Globals } from 'projects/core/src/globals';
import { ActivitiesDetailsComponent } from './../activities-details/activities-details.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeadlineDetailsComponent } from '../../deadlines/deadline-details/deadline-details.component';

import * as L from 'leaflet';
import * as ExtraMarkers from 'leaflet-extra-markers'
import { formatDate } from '@angular/common';
import { DocumentsDetailsComponent } from '../../documents/documents-details/documents-details.component';
import { CashFlowDetailsComponent } from '../../cash-flow/cash-flow-details/cash-flow-details.component';
import { FilterdateComponent } from '../../../modules/filterdate/filterdate.component';
import { MethodpaymentsService } from '../../../services/methodpayments.service';
import { AddressDetailsComponent } from '../../address/address-details/address-details.component';
import { DocumentDetail } from '../../../db/documents';
import { DocumentsTemplateService } from '../../../services/documents-template.service';
import { AddressesService } from '../../../services/addresses.service';
import { MapService } from 'projects/modules/src/app/map/services/map.service';
import { ActivitiesPreviewComponent } from '../preview/preview.component';

@Component({
  selector: 'app-activities-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ActivitiesListComponent extends ModelList<Activities> implements OnInit,AfterViewInit,OnDestroy {
  
  get current_user(){
    return Globals.user;
  }

  @ViewChild("modalPlanner")
  modalPlanner:any;
  modalPlannerRef:any;
  activityPlanner:any={};

  STATUS_PAID_OK=1
  STATUS_PAID_PARTIAL=2
  STATUS_PAID_NO_PAID=3
  STATUS_PAID_ATTEMPT=4
  
  
  @ViewChild(FilterdateComponent)
  FilterdateComponent:FilterdateComponent;

  @HostListener('document:click', ['$event']) 
  clickout(event) 
  { 
    if(event.target.classList.contains("openActivity")){
      let record2open=new Activities();
      record2open['id']=event.target.getAttribute("data-id");
      this.openDetail(record2open); 
    }
    
  } 
  @Input()
  modeView=0; // 1 == Lista ; 2 == Mappa ; 3 == Ibrido

  @Input()
  map_height="80vh";

  layers=[];
  min_latitude:number=0;
  max_latitude:number=0;
  min_longitude:number=0;
  max_longitude:number=0;
  list_custom_layer:any=[];
  private map:L.Map;
  markerLayer:L.LayerGroup;
  legend_collapse=true;
  markerUser:L.LayerGroup;
  markerCustomLayer:L.LayerGroup;
  
  @ViewChild("rescheduleModal")
  rescheduleModal:TemplateRef<any>
  rescheduleModalRef;
  rescheduleAction;
  rescheduleRecord;

  @ViewChild("modalRescheduleMultiple")
  modalRescheduleMultiple:TemplateRef<any>
  modalRescheduleMultipleRef;
  rescheduleRecords=[];

  @Input()
  id_address:number;

  @Input()
  table:string;

  @Input()
  id_table:number;

  @Input()
  reference:any;

  @Input()
  filter_box:boolean=true;
  
  @Input()
  no_dateend:boolean=false;

  @Input()
  id_contract:number=0;

  @Input()
  default_filterdate=(this.mode!='embedded')?1:6;

  @Input()
  date_from: Date=new Date();
  
  @Input()
  date_to: Date=new Date();

  today=new Date;


  isSelectable=true; //definisce se il tasto seleziona  è  visualizzabile nella lista

  type_activities:Type[]=[];
  status_activities:Type[];
  users:User[];
  total_amount=0;
  total_paid=0;

  filter_search:Filter=new Filter();
  filter_search_city:Filter=new Filter();
  filter_date:Filter=new Filter();  
  filter_id_type:Filter=new Filter();
  filter_id_user:Filter=new Filter();
  filter_status:Filter=new Filter();
  filter_phase:Filter=new Filter();
  filter_id:Filter=new Filter();

  filter_id_address:Filter=new Filter();
  filter_table:Filter=new Filter();
  filter_id_table:Filter=new Filter();
  filter_status_address:Filter=new Filter();
  filter_contract:Filter=new Filter();
  filter_method_payment:Filter=new Filter();
  filter_product:Filter=new Filter();
  methodpayments=[];
  isFilterSet:boolean=false;
  loadingMap=false;

  enableFilterProduct=false;
  modeShow=0; //definisce se mostrare solo le attività dell'anno corrente o meno

  intervalGetUserPosition;
  constructor(
    private fb1: UntypedFormBuilder,
    private activitiesService: ActivitiesService,
    private typesService: TypesService,
    private userService:UserService,
    private notificationService:NotificationService,
    private methodpaymentsService:MethodpaymentsService,
    private modalService:NgbModal,
    private documentTemplateService:DocumentsTemplateService,
    private addressesService:AddressesService,
    private mapService:MapService
    
  ) {
    super(activitiesService,fb1);
    this.modulename="activities";
    this.detailViewModal=ActivitiesDetailsComponent

    


   }

  ngOnInit(): void {
    this.title = 'Attività';
    super.ngOnInit.apply(this, arguments);
  
    if(this.mode=="embedded"){
      this.modeShow=parseInt(this.module?.getParam("default_modeview",0));
      this.modeView=1;
    }else{
      if(this.modeView==0)
        this.modeView=this.module.getParam("default_view",1);
    }

    this.paging_count = 24;
    
    this.methodpaymentsService.getMethods().subscribe((items_m)=>{
      this.methodpayments=items_m;
    });

    this.typesService.getTypes("activities").subscribe((items)=>{
      this.type_activities=items;
    });

    this.userService.getUsers().subscribe((items)=>{
      this.users=items;
    });
    if(Globals.events['savingActivityEvent']){
      Globals.events['savingActivityEvent'].subscribe(()=>{
        this.updateList();
      });
    }
    

    this.afterGetItems=()=>{


      this.activitiesService.getTotals(this.filter,this.orderingList,this.advancedFilter).subscribe((item)=>{
        if(item){
          this.total_amount=item.total_amount;
          this.total_paid=item.total_paid;
        }
      });

      for(let r of this.list)
        try{
          r.missingValues=JSON.parse(r.missingValues.toString());
        }catch{
          r.missingValues=[];
        }


      if(this.modeView==2 || this.modeView==3){
        this.updateMap();
      }
    }

    if(this.modeView==2){
      
    }

   

    this.filter_date.mode=FilterMode.date;
    this.filter_date.fields=[];
    this.filter_date.fields.push("a.date");
    this.filter_date.value=Helper.convertDateControl(this.date_from);
    this.filter_date.value2=Helper.convertDateControl(this.date_to); 
    this.filter.push(this.filter_date);


    if(!this.filter_box)
      this.updateList();
  }

  ngAfterViewInit(){
    
    if(this.modeView==2 || this.modeView==3){
      this.initMap();
      this.intervalGetUserPosition=setInterval(()=>{
        this.getUserPosition();
      },10000);
      this.getUserPosition();

      this.getLayerMap();
    }
    
  }

  ngOnDestroy(){
    if(this.intervalGetUserPosition){
      
      clearInterval(this.intervalGetUserPosition);
    }
  }

  private initMap():void{

   
    if(this.mode=="embedded")
      return;
   
    this.map = L.map('map', {
      center: [ 38.1037, 15.6369 ],
      zoom: 12,

    });

   
    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19
    });

    this.map.on("zoomend",this.onMapMove.bind(this));
    this.map.on("dragend",this.onMapMove.bind(this));

    
    tiles.addTo(this.map);

    this.mapService.getLayers(1).subscribe((items)=>{
      this.layers=items;
    });
  }

  onMapMove(event=null):void{

    
    this.max_latitude=this.map.getBounds().getNorthWest().lat;
    this.min_latitude=this.map.getBounds().getSouthEast().lat;
    this.max_longitude=this.map.getBounds().getSouthEast().lng;
    this.min_longitude=this.map.getBounds().getNorthWest().lng;
  
  }

  setFilters():void{


    

    this.filter_status.mode=FilterMode.normal;
    this.filter_status.fields=[];
    this.filter_status.fields.push("a.status");
    this.filter_status.value="1";
    this.filter.push(this.filter_status);



    /*
    this.date_from=this.today;
    this.date_to.setDate(this.today.getDate()+30);
    */

    
    this.filter_id.mode=FilterMode.normal;
    this.filter_id.fields=[];
    this.filter_id.fields.push("a.id");
    this.filter_id.value="";
    this.filter.push(this.filter_id);


    this.filter_id_type.mode=FilterMode.normal;
    this.filter_id_type.fields=[];
    this.filter_id_type.fields.push("a.id_type");
    this.filter_id_type.value="";
    this.filter.push(this.filter_id_type);

    this.filter_id_user.mode=FilterMode.normal;
    this.filter_id_user.fields=[];
    this.filter_id_user.fields.push("a.id_user");
    this.filter_id_user.value="";
    this.filter.push(this.filter_id_user);

    
    this.filter_id_address.mode=FilterMode.normal;
    this.filter_id_address.fields=[];
    this.filter_id_address.fields.push("a.id_address");
    this.filter_id_address.value="";
    this.filter.push(this.filter_id_address);
    
    this.filter_table.mode=FilterMode.normal;
    this.filter_table.fields=[];
    this.filter_table.fields.push("a.table");
    this.filter_table.value="";
    this.filter.push(this.filter_table);

    this.filter_id_table.mode=FilterMode.normal;
    this.filter_id_table.fields=[];
    this.filter_id_table.fields.push("a.id_table");
    this.filter_id_table.value="";
    this.filter.push(this.filter_id_table);

    this.filter_product.mode=FilterMode.normal;
    this.filter_product.fields=[];
    this.filter_product.fields.push("p.sn");
    this.filter_product.fields.push("p.matricola");

    this.filter_product.value="";
    this.filter.push(this.filter_product);



    this.filter_search.mode=FilterMode.like;
    this.filter_search.fields=[];
    this.filter_search.fields.push("addr.name");
    this.filter_search.fields.push("a.description");
    
    this.filter_search.value="";
    this.filter.push(this.filter_search);

    this.filter_search_city.mode=FilterMode.like;
    this.filter_search_city.fields=[];
    this.filter_search_city.fields.push("a.city");
    this.filter_search_city.fields.push("a.address");
    this.filter_search_city.value="";
    this.filter.push(this.filter_search_city);

    this.filter_method_payment.mode=FilterMode.contain;
    this.filter_method_payment.fields=[];
    this.filter_method_payment.fields.push("a.method_payment");
    this.filter_method_payment.value="";
    this.filter.push(this.filter_method_payment);
/*
    this.filter_status_address.mode=FilterMode.normal;
    this.filter_status_address.fields=[];
    this.filter_status_address.fields.push("addr.status");
    this.filter_status_address.value="1";
    this.filter.push(this.filter_status_address);

*/
    this.filter_phase.mode=FilterMode.normal;
    this.filter_phase.fields=[];
    this.filter_phase.fields.push("a.phase");
    this.filter_phase.value="";
    this.filter.push(this.filter_phase);

    if(this.id_contract>0){

      this.filter_contract.mode=FilterMode.custom;
      this.filter_contract.fields=[];
      this.filter_contract.value="(a.id_table="+this.id_contract.toString()+" AND a.table='contracts') OR (a.id_table IN (SELECT id FROM contractsinstallments WHERE id_contract="+this.id_contract.toString()+") AND a.table='contractsinstallments')";
      this.filter.push(this.filter_contract);
    }


    this.ordering.mode=OrderingMode.discendent;  
    this.ordering.field="a.date,a.time";
    
    let ordering_priority:Ordering={} as Ordering;
    ordering_priority.mode=OrderingMode.discendent;
    ordering_priority.field="a.priority";
    this.orderingList.push(ordering_priority);

    if(this.mode=="" || this.mode==undefined)
      this.advancedFilter=Globals.navigation.getStateFilters(this.constructor.name,this.filter);


    this.isFilterSet=true;
  }
  ngOnChanges():void{
    if(this.id_table>0  || this.id_contract>0 || this.id_address>0)
      this.updateList();
  }

  updateList(data_type=0):void{

    if(this.mode=="embedded"){ //non avviare la ricerca fino a quando non si è impostato l'id_table
      if((this.id_table==0 || this.id_table==undefined) && (this.id_address==0 || this.id_address==undefined))
     
        return;

      
    }
    
    if(!this.isFilterSet)
      this.setFilters();

      if(this.id_address>0){
        this.filter_id_address.value=this.id_address.toString();
      }
    if(this.id_table>0 && this.table!=""){
      this.filter_table.value=this.table;
      this.filter_id_table.value=this.id_table.toString();
      
    }

    

    if(data_type==11 || this.mode=="embedded"){
      this.ordering.mode=OrderingMode.ascendent;  
      this.ordering.field="a.date";
    }

    if(this.modeView==2){
      this.paging_count=10000;
    }

    if(this.filter_product.value!="")
      this.other_params=["","installations","p"];

    this.getItems();
  }

  add():void{
    
      this.openDetail();
      
  }


  notify(r:Activities){
    
    this.activitiesService.getItem(r.id).subscribe((record)=>{
      this.addressesService.getItem(r.id_address).subscribe((result)=>{
        let contacts:Contact[]=result.contacts;
        this.notificationService.showPreviewNotification(contacts,record,"activities",()=>{

        });

      })
    });

    

    /*
    this.activitiesService.getItem(r.id).subscribe((record)=>{
    
      switch(record.table){
        case "products":
          contacts=record.reference['shop']['addressItem']['contacts'];
          id_address=record.reference['shop']['addressItem']['id'];
          break;
        case "shops":
          contacts=record.reference['addressItem']['contacts'];
          id_address=record.reference['addressItem']['id'];
          break;
        case "contracts":
          contacts=record.reference['shop']['addressItem']['contacts'];
          id_address=record.reference['shop']['addressItem']['id'];
          break;
        case "addresses":
            contacts=record.reference['contacts'];
            id_address=record.reference['id'];
            break;
            
    
        
      }



      this.notificationService.showPreviewNotification(contacts,record,"activities",()=>{

      });
      

    });
*/
    
    
  }


  confirmActivities(r:Activities){

    if(this.checkPermissions("save")){
      //riprendi tutti i dati dell'activities
      this.activitiesService.getItem(r.id).subscribe((record)=>{
        record.phase=3;
        this.activitiesService.save(record,(id)=>{
          let deadlinerulesService:DeadlinerulesService=new DeadlinerulesService();
          deadlinerulesService.getRule("activities",record,()=>{});
        });
      });
    }
    
  }

  reschedule(r:Activities){

    this.activitiesService.getItem(r.id).subscribe((record)=>{
      this.rescheduleRecord=record;
      this.rescheduleModalRef=this.modalService.open(this.rescheduleModal);
    });
  }

  confirmReschedule(){
    if(this.rescheduleAction==1){ //crea agenda
      Globals.modal.showModal(DeadlineDetailsComponent,[
        {"name":"mode","value":"modal"},
        {"name":"date","value":this.rescheduleRecord.reschedule},
        {"name":"id_address","value":this.rescheduleRecord.id_address},
        {"name":"reference","value":this.rescheduleRecord.reference},
        {"name":"id_table","value":this.rescheduleRecord.id_table},
        {"name":"table","value":this.rescheduleRecord.table}
        
      ],(instance)=>{
          if(instance!=null){
            this.getItems();
          }
        });
    }
    if(this.rescheduleAction==2){ //modifica attività
      this.openDetail(this.rescheduleRecord,{"name":"new_date","value":this.rescheduleRecord.reschedule});
    }

    this.closeReschedule();
  }

  closeReschedule(){
    this.rescheduleModalRef.close("success");
  }

  
  private updateMap(): void {
  
    
    if(this.map==undefined){
      this.initMap();
    }else{
      if(this.markerLayer!=undefined)
        this.map.removeLayer(this.markerLayer);
    }

    if(this.list.length==0)
      return;

      this.loadingMap=true;

    this.markerLayer= L.layerGroup();

    let arrayOfLatLngs=[];
    for(let r of this.list){

      let location=this.getLocation(r);

        if(location['name'] && location['latitude']>0 && location['longitude']>0){
        
          let c=L.latLng(location['latitude'],location['longitude']);

         
          let today=this.isToday(r.date);
          let numberDay=this.calculateDiff(Helper.convertString2Date(r.date.toString()));

          let phase="";
          let color;
          let prefix="";
          if(r.phase==1){
            phase=`<i class="text-warning far fa-lg fa-2x fa-clock" title="In corso"></i>`;
            color="yellow";
          }
          if(r.phase==2){
            phase=`<i class="text-success fa fa-2x fa-check" title="Completata"></i>`;
            color="green";
          }
          if(r.phase==3){
            phase=`<i class="text-success fa fa-lg fa-2x fa-check-double" title="Confermata"></i>`;
            color="green";
          }
          if(r.phase==4){
            phase=`<i class="text-warning fa fa-lg fa-2x fa-exclamation" title="Rischedulata"></i>`;
            color="yellow";
            prefix="text-red";
          }

          let icon=L.ExtraMarkers.icon({
            icon: 'fa-user fa-number initials',
            markerColor: color,
            shape:today?'circle':'star',
            prefix: prefix,
            number:location['name'].substr(0,3).toUpperCase(),
            
          });

          let m=L.marker(c,{icon:icon });


          let popup=`
            <div class="row">
              <div class="col-md-10">
                <strong>${today?"Oggi":(numberDay>0?"Fra "+numberDay+" giorni":numberDay+" giorni fa")} ${formatDate(r.date.toString(),"dd/MM/yyyy","it")}</strong><br/>
                <strong>${location['name']}</strong><br/>
                ${r.type!=null?r.type:""} ${r.description} by <span class="badge badge-info">${r.username}</span>
                <br/><br/><button class="btn btn-sm btn-block btn-secondary openActivity" data-id='${r.id}'>Apri attività</button>
              </div>
              <div class="col-md-2 px-0 pt-5">
                ${phase}
              </div>
              
            </div>
          
          
          `;
          
          m.bindPopup(popup);
          m.on("click",function(event){
            m.openPopup();
          });

          arrayOfLatLngs.push(c)
          this.markerLayer.addLayer(m);
        }
      
    }


    this.map.addLayer(this.markerLayer);
    this.loadingMap=false;
    window.dispatchEvent(new Event('resize'));
  }


  getLocation(record){
    let result={};

    if(record.reference){
      switch(record.table){
        case "installations":
          if(record.reference.shop){
            result['latitude']=record.reference.shop.latitude;
            result['longitude']=record.reference.shop.longitude;
            result['name']=record.reference.shop.name;
          }
          break;

        case "shops":
          if(record.reference){
            result['latitude']=record.reference.latitude;
            result['longitude']=record.reference.longitude;
            result['name']=record.reference.name;
          }
          break;

        case "contracts":
          if(record.reference.shop){
            result['latitude']=record.reference.shop.latitude;
            result['longitude']=record.reference.shop.longitude;
            result['name']=record.reference.shop.name;
          }
          break;
          
      }
    }else{
      result['latitude']=record.latitude;
      result['longitude']=record.longitude;
      result['name']=record.name;
    }
    return result;
  }

  calculateDiff(dateSent){
    let currentDate = new Date();
    dateSent = new Date(dateSent);

    return Math.floor((Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())- Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) ) /(1000 * 60 * 60 * 24));
}

  openDocument(document){
    Globals.modal.showModal(DocumentsDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"id","value":document['id']}
    ],()=>{

    })
  }


  openCashflow(id_cashflow){
    
    if(id_cashflow>0){
      Globals.modal.showModal(CashFlowDetailsComponent,[
        {"name":"mode","value":"modal"},
        {"name":"id","value":id_cashflow}
      ],()=>{

      })
    }
  }
  

  getUserPosition(){
    this.activitiesService.getGPSposition().subscribe((result)=>{

      if(this.map==undefined){
        this.initMap();
      }else{
        if(this.markerUser!=undefined)
          this.map.removeLayer(this.markerUser);
      }

      this.markerUser= L.layerGroup();

      for(let u of result){

        let c=L.latLng(u['latitude'],u['longitude']);
        
        let icon=L.ExtraMarkers.icon({
          icon: 'fa-user fa-number initials',
          markerColor: "blue",
          shape:"square",
          prefix: '',
          number:u['user']?(u['user']['name']?u['user']['name'].substr(0,3).toUpperCase():""):"",
          
        });
  
        let m=L.marker(c,{icon:icon });

        let popup=`
        <div class="row">
          <div class="col-md-12">
            
            Operatore: <strong>${u['user']?u['user']['name']:""}</strong><br/>
            Ultimo aggiornamento: <strong>${formatDate(u['date'].toString(),"dd/MM/yyyy hh:mm","it")}</strong><br/>
            
          </div>
          
          
        </div>
      
      
      `;
      
      m.bindPopup(popup);
      m.on("click",function(event){
        m.openPopup();
      });

      this.markerUser.addLayer(m);
    }

      

      this.map.addLayer(this.markerUser);
    

    });
  }

  hasCashflowPaid(record){
    if(record.cashflow){
      if(record.cashflow.paid>0)
        return true;
      else
        return false;
    }

    return false;
  }
  

  openRescheduleMultiple(){

    if(this.form.value.id.length==0){
      Globals.message.showToaster("Selezionare almeno un elemento",ToastMode.WARNING);
      return;
    }
    let ids=this.form.value.id;
    this.rescheduleRecords=[];
    for(let id of ids){
      for(let record of this.list){
        if(record.id==id){
          this.rescheduleRecords.push(record);
        }
      }
    }

    this.modalRescheduleMultipleRef=this.modalService.open(this.modalRescheduleMultiple,{size:'lg'});
  }

  closeRescheduleMultiple(){
    this.modalRescheduleMultipleRef.close("success");
  }

  confirmRescheduleMultiple(){

    this.activitiesService.saveMultiple(this.rescheduleRecords,()=>{
      this.closeRescheduleMultiple();
      this.updateList();
    });

  }

  onSearchEnter(){
    this.updateList();
    /*
    if(this.filter_search.value!="" || this.filter_id.value!="" || this.filter_search_city.value!=""){
      this.FilterdateComponent.setDate(6);
     
    }else{
      this.updateList();
    }
    */
  
  }

  statusPaid(activities){

    let status=this.STATUS_PAID_ATTEMPT;

    if(activities.phase>1){
      if((activities.amount>0 || activities.paid>0) && activities.enable_accounting){
        if(activities.id_cashflow==0){
          status=this.STATUS_PAID_NO_PAID;
        }else{
          //verifica se il pagamento è parziale
          if(activities.cashflow && activities.cashflow.paid>=activities.paid){
            status=this.STATUS_PAID_OK;
          }else{
            status=this.STATUS_PAID_PARTIAL;
          }
          
        }
      }

      if(activities.documents && activities.documents.length>0){
        if(activities.documents[0].paid==0){
          if(status!=this.STATUS_PAID_OK && status!=this.STATUS_PAID_PARTIAL)
            status=this.STATUS_PAID_NO_PAID;
        }
        else{
          //verifica il pagamento
          let total_paid=0;
          total_paid=total_paid+parseFloat(activities.documents[0].paid);
          if(total_paid>=parseFloat(activities.paid)){
            status=this.STATUS_PAID_OK;
          }else{
            status=this.STATUS_PAID_PARTIAL;
          }
          
        }
          
      }
    }

    return status;
  }

  openAddress(id_address){
    Globals.modal.showModal(AddressDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"id","value":id_address}
      
    ],()=>{

    });
    
  }

  setType(t){
      //verifica se nei parametri è definita la tabella installations
      this.enableFilterProduct=false;
      try{
      t.params=JSON.parse(t.params);
     }catch{
      t.params=[];
     }
     if(t.params['tables'].includes("installations")){
      this.enableFilterProduct=true;
     }
      
  }

  isShowed(activity:Activities){
    if(this.modeShow==1){ //mostra solo quelle di quest'anno
      if(new Date(activity.date).getFullYear()==new Date().getFullYear())
        return true;
      else
        return false;
    }

    if(this.modeShow==2){ //mostra solo quelle di quest'anno
      //calcola 365 in meno ad oggi
      let d365=  new Date();
      d365.setDate(d365.getDate()-365);
      
      if(new Date(activity.date)>d365)
        return true;
      else
        return false;
    }


    return true;
  }

  addDocument(){
    if(this.form.value.id.length==0){
      Globals.message.showToaster("Selezionare almeno un elemento",ToastMode.WARNING);
      return;
    }

    let drecord:Activities=new Activities();
    drecord.id_address=this.id_address;

   
    let details:DocumentDetail[]=[];

    let ids=this.form.value.id;
    let activities=[];
    let total=0;
    let paid=0;
    for(let i=0;i<ids.length;i++){
      let id=ids[i];
      for(let record of this.list){
        if(record.id==id){
          activities.push(record);

          let d:DocumentDetail=new DocumentDetail();
          d.id=0;
          d.id_product=0;
          d.description=new Date(record.date).toLocaleDateString()+" - "+record.description;
          d.netprice=record.amount;
          d.tax=record.tax;
          details.push(d);
          total=total+(d.netprice*(1+d.tax/100));
          paid=paid+record.paid;
        }
      }

      
    }

    this.documentTemplateService.createOpenDocument("activities",drecord,total-paid,"",details,()=>{
       
      //verifica 
       this.updateList();
    });


  }

  getLayerMap(){
    this.mapService.getLayers(1).subscribe((items)=>{
      this.layers=items;
    });
  }

  onChangeLayer(layer){

    layer['status']==1?0:1;
    this.mapService.save(layer,()=>{
      this.mapService.getPois(this.min_latitude,this.max_latitude,this.min_longitude,this.max_longitude,this.date_from,this.date_to).subscribe((items)=>{
        this.list_custom_layer=items;
        this.updateCustomLayerMap();
      })
    },false,false);

    
  }


  private updateCustomLayerMap(): void {

    if(this.map==undefined){
      this.initMap();
    }else{
      if(this.markerCustomLayer!=undefined)
        this.map.removeLayer(this.markerCustomLayer);
    }

    this.markerCustomLayer= L.layerGroup();

    let arrayOfLatLngs=[];
    for(let r of this.list_custom_layer){
      if(r.latitude>0 && r.longitude>0){
       //this.addToLegend(r);
        let c=L.latLng(r.latitude,r.longitude);
        let icon=L.ExtraMarkers.icon({
          icon: 'fa-user fa-number',
          markerColor:  r.color,
          shape: r.icon,
          prefix: 'fa',
          number:r.icon_description,
          
        });

        let m=L.marker(c,{icon:icon });
       

        
        m.bindPopup(`
          <strong>${r.title!=null?r.title:""}</strong><br/>
          <br/><br/><button class="btn btn-sm btn-secondary openRecord" data-id='${r.id}' data-table='${r.table}'>Apri</button>
          `
        );
        m.on("click",function(event){
          m.openPopup();
        });

        arrayOfLatLngs.push(c)
        this.markerCustomLayer.addLayer(m);
      }
    }


    this.map.addLayer(this.markerCustomLayer);
    
    
  }

  centerOnMap(activity){
    
      this.map.setView(L.latLng(parseFloat(activity.latitude),parseFloat(activity.longitude)),16);
  
   
  }


  openModalPlanner(activity){
    //ottieni i contatti dell'anagrafica
    this.addressesService.getItem(activity.id_address).subscribe((address)=>{
      this.activityPlanner={"address":address,"activity":activity,"id_activity":activity.id,"date":activity.date,"note":activity.note,"subject":"","description":"","id_user":activity.id_user,"phase":activity.phase};
      this.modalPlannerRef=this.modalService.open(this.modalPlanner);
   
    })


  }

  closeModalPlanner(){
    this.modalPlannerRef.close("success");
  }

  savePlanner(){
    this.activitiesService.savePlanner(this.activityPlanner,()=>{
      this.closeModalPlanner();
      this.updateList();
    }
  );
  }


  /**
   * Verifica se l'attività potrebbe essere chiusa
   * @param activity 
   */
  checkOpeningTime(activity){
    var opening_time=[];
    //prendi i dati di apertura
    if(typeof(activity.opening_time)=="string"){
      try{
        opening_time=JSON.parse(activity.opening_time);
      }catch{
        opening_time=[];
      }
    }

    if(Array.isArray(opening_time)){
      const act_date=new Date(activity.date);

      for(let d of opening_time){
        if(d.day==act_date.getDay()){
          if(d.from1=="" && d.to1=="" && d.from2=="" && d.to2==""){
            return false;
          }
        }
      }
    }

    return true;

  }

  openPreview(record:any){
    Globals.modal.showModal(ActivitiesPreviewComponent,[{"name":"id","value":record.id}],()=>{

    });
  }
}
